import { css } from '@emotion/css'
import { fontSize, fontWeight, spacing, shorthandHelper, textStyles, colors } from '@offerzen/pinata'

const styles = {
  text: css({
    ...textStyles,
    marginTop: spacing.medium,
    marginBottom: spacing.default,
  }),

  upload: css({
    width: '100%',

    label: {
      marginBottom: 0,
      fontSize: fontSize.default,
    },
  }),

  error: css({
    marginTop: spacing.medium,
  }),

  cardFooter: css({
    display: 'flex',
    justifyContent: 'flex-end',
    margin: shorthandHelper([spacing.large, -spacing.large, -spacing.large]),
    padding: spacing.large,
    borderTop: `1px solid ${colors.mystic}`,
  }),

  heading: css({
    fontWeight: fontWeight.medium,
    color: colors.blackPearl,
  }),
}

export default styles
